export default {
	namespaced: true,
	state:      () => ({
		activeTags: null,
	}),
	mutations: {
		setActiveTagList(state, eventTags) {
			state.activeTags = eventTags;
		},
	},
	actions: {
		setActiveTags({ commit }, eventTags) {
			commit('setActiveTagList', eventTags || []);
		},
		resetActiveTags({ commit }) {
			commit('setActiveTagList', null);
		},
	},
	getters: {
		activeTags: (state, getters, rootState, rootGetters) => {
			const allEventTags = rootGetters['event/tags'];
			if (rootGetters['app/isTaggingToolMode']) {
				return state.activeTags || allEventTags;
			}
			return allEventTags;
		},
	},
};
